import { v4 as uuidv4 } from 'uuid';
import axios, { AxiosError } from 'axios';
import { Environment } from '../../environment';
import { Api } from './axios-config';

export interface IListagemAdiantamentos {
  guuidvale: string;
  nome: string;
  datadesconto: Date;
  historico: string;
  valor: number;
  status: boolean;
}

export interface IDetalheAdiantamentos {
  guuidcolhedor: string;
  nome: string;
  datadesconto: Date;
  historico: string;
  valor: number;
  status: boolean;
} 

export interface IRadiantamento {
  guuidvale: string; 
  nome: string;
  historico: string;
  datadesconto: Date;
  valor: number;
  status: boolean;
}

type TotalCount = {
  data: IListagemAdiantamentos[];
  totalCount: number;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const getAll = async (page = 1, filter = ''): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/adiantamentos?page=${page}&limit=${22}&filter=${filter}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || 22),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const getById = async (id: string): Promise<IDetalheAdiantamentos | Error> => {
  try {
    const { data } = await Api.get(`/adiantamentos/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const create = async (dados: Omit<IDetalheAdiantamentos, 'nome' | 'status'>): Promise<string | Error> => {
  try {
    const guuid = uuidv4();
    const { data } = await Api.post<IDetalheAdiantamentos>('/adiantamentos', {guuidvale :guuid, ...dados});
    if (Object.keys(data).length === 0) {
      return 'guuid';
    }

    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const updateById = async (id: string, dados: Omit<IDetalheAdiantamentos, 'nome' | 'status'>): Promise<void | Error> => {
  try {
    await Api.put(`/adiantamentos/${id}`, dados);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/adiantamentos/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const Relatorio = async (datainicial: string, datafinal: string, status: boolean): Promise<IRadiantamento[] | Error> => {
  try {
    const urlRelativa = `/radiantamento?datainicial=${datainicial}&datafinal=${datafinal}&status=${status}`;
    const { data } = await Api.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export const AdiantamentoService = {
  getAll,
  create,
  getById,
  updateById,
  deleteById,
  Relatorio,
};